import { t } from "@travily/i18n";
import { EmptyState } from "@ui/components/EmptyState";
import { Illustration } from "@ui/components/Illustration";

export interface RestrictedProfileProps {
  className?: string;
  displayName: string;
}

export function RestrictedProfile({ className, displayName }: RestrictedProfileProps) {
  return (
    <EmptyState
      className={className}
      description={t("components.views.shared.restricted_profile.description", { name: displayName })}
      illustration={<Illustration name="restricted" />}
      title={t("components.views.shared.restricted_profile.title")}
    />
  );
}
